import { render, staticRenderFns } from "./Massive.vue?vue&type=template&id=47a66a9a&scoped=true&"
import script from "./Massive.vue?vue&type=script&lang=js&"
export * from "./Massive.vue?vue&type=script&lang=js&"
import style0 from "./Massive.vue?vue&type=style&index=0&id=47a66a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a66a9a",
  null
  
)

export default component.exports